import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'mainWarp',
  props: {
  topHeight: {
    type: Number,
    default: 0,
  },
  hasMin: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

let vp = __props;
const height = computed(() => {
  const h = vp.topHeight + 176;
  return vp.hasMin ? { height: `calc(100vh - ${h}px)` } : {};
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "main-page-warp",
    style: _normalizeStyle(height.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})